/* Waymino v7 · lo que se mueve en la portada.
   Generado desde waymino-landing-v7.html el 12/08/2026. Sin la cabecera ni el
   menú: en la tienda los pone el tema. */

(function(){
'use strict';
var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
var raiz = document.querySelector('.wm7') || document;
var $ = function(s,c){ return (c||raiz).querySelector(s); };
var $$ = function(s,c){ return [].slice.call((c||raiz).querySelectorAll(s)); };

/* ---------- CONFIGURACIÓN EDITABLE ---------- */
/* El número de reservas viene del ajuste de la sección (data-reservadas), no
   de aquí: así lo cambias en el editor de temas según entren de verdad. */
var WM = { total:200, reservadas:0 };
(function(){
  var rej = document.querySelector('#nums');
  var n = rej && parseInt(rej.getAttribute('data-reservadas'), 10);
  if(!isNaN(n) && n >= 0) WM.reservadas = Math.min(n, WM.total);
})();

/* ---------- progreso + cabecera ---------- */
/* En la tienda, la cabecera y el menú son los del tema: aquí solo queda la
   barra de progreso. Con guardas: un elemento que falte no puede tumbar la página. */
var bar = $('#prog'), raf = null;
function onScroll(){
  var h = document.documentElement;
  if(bar) bar.style.transform = 'scaleX(' + (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) + ')';
  raf = null;
}
addEventListener('scroll', function(){ if(!raf) raf = requestAnimationFrame(onScroll); }, {passive:true});
onScroll();

/* ---------- aparecer ---------- */
var io = new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
}, {rootMargin:'0px 0px -12% 0px', threshold:.1});
$$('[data-rev]').forEach(function(el){ REDUCE ? el.classList.add('in') : io.observe(el); });
/* Red de seguridad: si el navegador no dispara el observador (pestaña en
   segundo plano, navegador raro, JS a medias), a los 2,5 s se enseña todo.
   Sin esto, un fallo del observador deja la página EN BLANCO — visto al
   probarla dentro de un iframe. Una tienda no se puede permitir eso. */
setTimeout(function(){ $$('[data-rev]').forEach(function(el){ el.classList.add('in'); }); }, 2500);

/* ---------- titular palabra a palabra ---------- */
(function(){
  var h1 = $('#h1'); if(!h1) return;
  $$('.w i', h1).forEach(function(i,k){ i.style.transitionDelay = (0.1 + k*0.055) + 's'; });
  requestAnimationFrame(function(){ h1.classList.add('go'); });
  setTimeout(function(){ h1.classList.add('go'); }, 1200);
})();

/* ---------- la pulsera en 3D ---------- */
function pulsera3d(stageSel, shineSel){
  var stage = $(stageSel), shine = $(shineSel);
  if(!stage) return;
  var wrap = stage.parentElement;
  var rx = -6, ry = 0, tx = 0, cur = {rx:-6, ry:0}, arrastrando = false, x0 = 0, ry0 = 0;
  function pintar(){
    cur.rx += (rx - cur.rx) * .12;
    cur.ry += (ry - cur.ry) * .12;
    stage.style.transform = 'rotateX(' + cur.rx.toFixed(2) + 'deg) rotateY(' + cur.ry.toFixed(2) + 'deg)';
    if(shine) shine.style.transform = 'translateX(' + (-60 + (cur.ry + 22) / 44 * 120).toFixed(1) + '%)';
    requestAnimationFrame(pintar);
  }
  if(!REDUCE) requestAnimationFrame(pintar);
  wrap.addEventListener('pointermove', function(e){
    if(arrastrando) return;
    var r = wrap.getBoundingClientRect();
    ry = ((e.clientX - r.left) / r.width - .5) * 30;
    rx = -6 - ((e.clientY - r.top) / r.height - .5) * 14;
  });
  wrap.addEventListener('pointerleave', function(){ if(!arrastrando){ rx = -6; ry = 0; } });
  stage.addEventListener('pointerdown', function(e){
    arrastrando = true; x0 = e.clientX; ry0 = ry;
    stage.setPointerCapture(e.pointerId);
    wrap.classList.add('moved');
  });
  stage.addEventListener('pointermove', function(e){
    if(!arrastrando) return;
    ry = Math.max(-26, Math.min(26, ry0 + (e.clientX - x0) * .22));
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    stage.addEventListener(ev, function(){ arrastrando = false; });
  });
}
/* En la portada ya no hay tarjeta: la pulsera gira de verdad (más abajo).
   pulsera3d() se queda para el bloque de la mitad de la página. */
pulsera3d('#p3dStage2','#p3dShine2');

/* ---------- la pulsera girando (portada) ----------
   36 fotogramas en una hoja de 6×6. Se avanza con `transform`, NO con
   background-position: aquello obligaba al navegador a repintar el elemento
   entero en cada fotograma reescalando una imagen de 2400 px, y en un móvil
   daba tirones. Con transform el trabajo lo hace la GPU componiendo una capa ya
   pintada. Da igual un iPhone nuevo que un Android de hace cinco años.
   Gira sola a ~9 fotogramas por segundo (4 s la vuelta) porque más rápido
   parece un GIF de anuncio y más lento parece que se ha colgado.
   Al arrastrarla la manda el dedo, y tras soltarla espera 900 ms antes de
   seguir sola: si arranca de golpe, parece que te ha quitado el control. */
(function(){
  var caja = $('#giro'), capa = $('#giroF');
  if(!caja || !capa) return;
  var N = 36, COL = 6, PASO = 100 / COL;   /* 16,6667 % del tamaño de la capa */
  var f = 0, arrastrando = false, x0 = 0, f0 = 0, quieta = 0, ultimo = 0;

  function pinta(){
    var i = ((Math.round(f) % N) + N) % N;
    capa.style.transform = 'translate3d(' + (-(i % COL) * PASO) + '%,' +
                          (-Math.floor(i / COL) * PASO) + '%,0)';
  }

  /* La hoja la pone Liquid en --hoja para no escribir aquí la URL del CDN.
     Se precarga con un Image() y solo se enseña cuando está entera: si no,
     lo primero que ve el visitante es media pulsera a medio descargar. */
  var hoja = getComputedStyle(caja).getPropertyValue('--hoja').trim()
               .replace(/^url\(\s*["']?/, '').replace(/["']?\s*\)$/, '');
  var img = new Image();
  img.onload = function(){ caja.classList.add('lista'); pinta(); };
  img.onerror = function(){ caja.classList.add('lista'); };   /* nunca dejarla invisible */
  if(hoja) img.src = hoja; else caja.classList.add('lista');

  var envoltorio = caja.closest ? caja.closest('.p3d') : null;
  caja.addEventListener('pointerdown', function(e){
    arrastrando = true; x0 = e.clientX; f0 = f;
    if(envoltorio) envoltorio.classList.add('moved');
    caja.setPointerCapture(e.pointerId);
  });
  caja.addEventListener('pointermove', function(e){
    if(!arrastrando) return;
    /* una vuelta entera cada ~340 px de arrastre: ni pesada ni nerviosa */
    f = f0 - (e.clientX - x0) * (N / 340);
    pinta();
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    caja.addEventListener(ev, function(){ arrastrando = false; quieta = performance.now(); });
  });

  /* VAIVÉN, NO VUELTA ENTERA.
     Dando la vuelta completa hay medio giro en el que se ve la trasera: en un
     bucle de 4 s el sello desaparece unos 2. En una portada eso es la mitad del
     tiempo sin marca. Así que sola oscila ±6 fotogramas (±60°) alrededor del
     frente, con el seno haciendo el frenado en las puntas — nunca pierde el
     sello. La vuelta entera sigue estando: se llega arrastrando, que es donde
     el que quiere ver el cierre va a mirar. */
  var AMPL = 6, PERIODO = 54;                    // 54 pasos × 110 ms ≈ 6 s de ida y vuelta
  var fase = 0;

  (function bucle(t){
    requestAnimationFrame(bucle);
    if(REDUCE || arrastrando) return;
    if(quieta && t - quieta < 900) return;
    if(t - ultimo < 110) return;
    ultimo = t;
    fase += 1;
    var objetivo = AMPL * Math.sin(fase * 2 * Math.PI / PERIODO);
    /* Tras arrastrar, la pulsera puede haber quedado del revés. Se vuelve al
       vaivén por el camino corto y con suavizado, no de un salto. */
    var d = objetivo - f;
    d = ((d + N/2) % N + N) % N - N/2;
    f += d * 0.18;
    pinta();
  })(0);
})();

/* ---------- escasez y rejilla de 200 ----------
   Los reservados se pintan DESDE EL Nº 1 HACIA ARRIBA, no salpicados por la
   rejilla. Es la única forma coherente con lo que promete el texto de al lado:
   "los números se asignan por orden de reserva". Si se pintasen sueltos, un
   comprador que mire dos segundos ve que el nº 1 sigue libre y el 137 cogido,
   y la promesa se cae sola.
   `WM.reservadas` es el número REAL de reservas. En la tienda lo gobierna el
   ajuste "Cuántas van reservadas" de la sección, sin tocar código. */
(function(){
  var t = $('#ticks'), n = $('#nums'), txt = $('#scarTxt');
  var f1 = document.createDocumentFragment(), f2 = document.createDocumentFragment();
  /* Números con historia: dan relieve a la rejilla sin fingir ventas. */
  var HITOS = { 1:'El primero', 100:'La mitad', 200:'El último' };
  for(var i=1;i<=WM.total;i++){
    var a = document.createElement('i');
    if(i <= WM.reservadas) a.className = 'on'; else if(i===1) a.className = 'one';
    f1.appendChild(a);
    var b = document.createElement('i');
    b.dataset.n = 'Nº ' + String(i).padStart(3,'0') + (HITOS[i] ? ' · ' + HITOS[i] : '');
    if(i <= WM.reservadas) b.className = 'taken';
    else if(HITOS[i]) b.className = i === 1 ? 'one hito' : 'hito';
    f2.appendChild(b);
  }
  t.appendChild(f1); if(n) n.appendChild(f2);
  txt.innerHTML = WM.reservadas === 0
    ? '<b>Los ' + WM.total + ' números están libres.</b> Incluido el nº 1.'
    : '<b>Quedan ' + (WM.total - WM.reservadas) + ' de ' + WM.total + '</b> números de fundador.';
})();

/* ---------- ELIGE TU CAMINO ---------- */
(function(){
  var RUTAS = [
    { id:'portugues', nombre:'Camino Portugués', corto:'Portugués',
      desde:'Desde Lisboa · el que cruza O Porriño cada mañana',
      cuando:'Mejor época: primavera y septiembre', km:620, dias:26,
      hitos:['Lisboa','Coimbra','Porto','Ponte de Lima','Tui','O Porriño','Padrón','Santiago'],
      etapas:25,
      pueblos:['Lisboa','Vila Franca de Xira','Azambuja','Santarém','Golegã','Tomar','Alvaiázere','Alvorge','Cernache','Coimbra','Sernadelo','Águeda','Albergaria-a-Velha','São João da Madeira','Grijó','Porto','Vilarinho','Barcelos','Ponte de Lima','Rubiães','Tui','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'] },
    { id:'frances', nombre:'Camino Francés', corto:'Francés',
      desde:'Desde Saint-Jean-Pied-de-Port · el más caminado',
      cuando:'Mejor época: mayo, junio y septiembre', km:772, dias:33,
      hitos:['Saint-Jean','Pamplona','Logroño','Burgos','León','Astorga','Sarria','Santiago'],
      etapas:33,
      pueblos:['Saint-Jean-Pied-de-Port','Roncesvalles','Zubiri','Pamplona','Puente la Reina','Estella','Los Arcos','Logroño','Nájera','Santo Domingo de la Calzada','Belorado','San Juan de Ortega','Burgos','Hornillos del Camino','Castrojeriz','Frómista','Carrión de los Condes','Terradillos de los Templarios','Bercianos del Real Camino','Mansilla de las Mulas','León','Villar de Mazarife','Astorga','Foncebadón','Ponferrada','Villafranca del Bierzo','O Cebreiro','Triacastela','Sarria','Portomarín','Palas de Rei','Arzúa','O Pedrouzo','Santiago'] },
    { id:'costa', nombre:'Portugués de la Costa', corto:'Portugués Costa',
      desde:'Desde Porto, pegado al Atlántico',
      cuando:'Mejor época: de mayo a octubre', km:269, dias:12,
      hitos:['Porto','Vila do Conde','Viana do Castelo','A Guarda','Vigo','Redondela','Padrón','Santiago'],
      etapas:13,
      pueblos:['Porto','Labruge','Póvoa de Varzim','Marinhas','Viana do Castelo','Caminha','Porto Mougás','A Ramallosa','Vigo','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'] },
    { id:'norte', nombre:'Camino del Norte', corto:'Norte',
      desde:'Desde Irún, por la cornisa cantábrica',
      cuando:'Mejor época: junio a septiembre', km:825, dias:34,
      hitos:['Irún','Bilbao','Santander','Gijón','Ribadeo','Mondoñedo','Arzúa','Santiago'],
      etapas:36,
      pueblos:['Irún','San Sebastián','Zarautz','Deba','Markina-Xemein','Gernika','Lezama','Bilbao','Portugalete','Castro Urdiales','Laredo','Güemes','Santander','Santillana del Mar','Comillas','Colombres','Llanes','Ribadesella','Colunga','Villaviciosa','Gijón','Avilés','Muros de Nalón','Soto de Luiña','Cadavedo','Luarca','La Caridad','Ribadeo','Gondán','Mondoñedo','Abadín','Vilalba','Baamonde','Sobrado dos Monxes','Arzúa','O Pedrouzo','Santiago'] },
    { id:'ingles', nombre:'Camino Inglés', corto:'Inglés',
      desde:'Desde Ferrol · el más corto que da la Compostela',
      cuando:'Mejor época: todo el año', km:122, dias:6,
      hitos:['Ferrol','Pontedeume','Betanzos','Bruma','Sigüeiro','Santiago'],
      etapas:5,
      pueblos:['Ferrol','Pontedeume','Betanzos','Hospital de Bruma','Sigüeiro','Santiago'] }
  ];
  /* Geometría REAL de los cinco Caminos, sacada de las coordenadas que ya usa
     el generador del vídeo (lib/video/caminos.ts) y proyectada en un único
     encuadre común. Antes los cinco se dibujaban con la MISMA curva inventada
     y solo cambiaban los nombres: cualquiera que conozca el Camino lo cazaba. */
  var GEO = {"meta":{"W":1000,"H":812,"kmU":0.822,"sx":168.1,"sy":177.4},"rutas":{"frances":{"d":"M890.7 140.2C889.3 143.6,886.9 155.4,882.5 160.5C878.1 165.6,869.7 166.4,864.3 170.7C858.9 175.0,855.3 180.6,850.2 186.3C845.1 192.0,839.9 201.7,833.6 204.8C827.3 207.9,818.5 202.6,812.3 204.8C806.1 207.0,803.1 213.7,796.3 218.2C789.4 222.7,780.1 228.6,771.2 231.9C762.3 235.3,751.1 237.8,742.7 238.3C734.3 238.8,728.5 235.2,721.0 235.1C713.5 235.0,705.5 236.4,697.5 237.8C689.5 239.2,681.5 242.0,673.1 243.7C664.8 245.4,659.0 245.9,647.4 247.8C635.8 249.7,615.5 253.3,603.8 255.0C592.1 256.7,585.0 259.0,577.3 257.9C569.6 256.8,568.1 250.9,557.8 248.6C547.5 246.3,529.1 247.8,515.7 244.3C502.3 240.8,486.2 232.5,477.3 227.5C468.4 222.5,470.1 213.6,462.5 214.4C454.9 215.2,439.4 229.1,431.4 232.2C423.4 235.3,421.1 233.1,414.5 232.7C407.9 232.3,400.6 231.6,391.7 229.7C382.8 227.8,369.9 224.0,361.2 221.3C352.5 218.6,347.0 216.8,339.6 213.3C332.2 209.8,323.7 203.4,316.6 200.1C309.5 196.8,303.3 195.3,297.2 193.7C291.1 192.1,286.1 191.5,279.9 190.4C273.7 189.3,267.4 189.0,259.9 187.0C252.4 185.0,241.6 180.7,235.0 178.3C228.4 176.0,225.4 174.1,220.6 172.9C215.8 171.7,211.8 170.8,206.0 171.0C200.2 171.2,192.2 172.7,185.9 173.8C179.6 174.9,171.1 176.8,168.1 177.4","g":[{"n":"Saint-Jean","x":890.7,"y":140.2,"t":0,"tx":890.7,"ty":124.6,"a":"middle"},{"n":"Pamplona","x":850.2,"y":186.3,"t":0.094,"tx":868.1,"ty":189.4,"a":"start"},{"n":"Logroño","x":771.2,"y":231.9,"t":0.219,"tx":789.1,"ty":235,"a":"start"},{"n":"Burgos","x":647.4,"y":247.8,"t":0.375,"tx":647.4,"ty":232.2,"a":"middle"},{"n":"León","x":462.5,"y":214.4,"t":0.563,"tx":462.5,"ty":198.8,"a":"middle"},{"n":"Astorga","x":414.5,"y":232.7,"t":0.625,"tx":414.5,"ty":217.1,"a":"middle"},{"n":"Sarria","x":279.9,"y":190.4,"t":0.813,"tx":279.9,"ty":174.8,"a":"middle"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"tx":150.2,"ty":180.5,"a":"end"}],"m":[{"n":"Saint-Jean","x":890.7,"y":140.2,"t":0,"i":0,"tx":890.7,"ty":109,"a":"middle"},{"n":"Logroño","x":771.2,"y":231.9,"t":0.219,"i":2,"tx":807.1,"ty":238.1,"a":"start"},{"n":"Astorga","x":414.5,"y":232.7,"t":0.625,"i":5,"tx":414.5,"ty":201.5,"a":"middle"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7,"tx":132.2,"ty":183.6,"a":"end"}],"lista":["Saint-Jean","Pamplona","Logroño","Burgos","León","Astorga","Sarria","Santiago"],"bb":[168.1,140.2,890.7,257.9]},"portugues":{"d":"M109.3 723.3C111.0 719.5,115.0 708.0,119.5 700.4C124.0 692.8,130.3 685.1,136.1 677.7C141.9 670.3,147.9 663.1,154.2 655.8C160.5 648.5,169.6 641.9,174.1 633.9C178.6 625.9,179.7 616.8,181.4 607.6C183.1 598.4,184.8 585.3,184.4 578.5C184.0 571.7,180.7 571.6,179.2 567.0C177.7 562.4,175.1 557.5,175.5 551.1C175.9 544.8,181.1 536.4,181.4 528.9C181.7 521.4,178.0 514.1,177.4 506.0C176.8 497.9,178.2 486.9,177.7 480.1C177.2 473.3,175.3 472.2,174.4 465.1C173.5 458.0,174.0 445.0,172.5 437.4C171.0 429.8,167.7 425.3,165.6 419.7C163.5 414.1,160.6 409.7,159.8 403.5C159.0 397.3,160.5 390.6,160.7 382.3C160.9 374.0,160.5 363.4,161.1 353.6C161.7 343.8,164.1 332.1,164.3 323.5C164.5 314.9,163.5 307.4,162.5 301.7C161.5 296.0,159.2 291.8,158.5 289.3C157.8 286.8,157.8 289.6,158.2 286.7C158.6 283.8,160.4 275.2,160.7 271.8C161.0 268.4,159.6 269.1,159.8 266.4C160.0 263.7,161.2 258.8,161.8 255.7C162.4 252.6,164.1 251.3,163.5 248.1C162.9 244.9,159.0 242.1,158.2 236.4C157.4 230.7,158.8 220.4,158.5 213.7C158.3 207.0,155.1 202.1,156.7 196.0C158.3 189.9,166.2 180.5,168.1 177.4","g":[{"n":"Lisboa","x":109.3,"y":723.3,"t":0,"tx":127.2,"ty":713.9,"a":"start"},{"n":"Coimbra","x":181.4,"y":528.9,"t":0.31,"tx":199.3,"ty":519.5,"a":"start"},{"n":"Porto","x":159.8,"y":403.5,"t":0.517,"tx":177.7,"ty":394.1,"a":"start"},{"n":"Ponte de Lima","x":164.3,"y":323.5,"t":0.621,"tx":182.2,"ty":314.1,"a":"start"},{"n":"Tui","x":158.2,"y":286.7,"t":0.724,"tx":176.1,"ty":277.3,"a":"start"},{"n":"O Porriño","x":160.7,"y":271.8,"t":0.759,"tx":142.8,"ty":262.4,"a":"end"},{"n":"Padrón","x":156.7,"y":196,"t":0.966,"tx":174.6,"ty":199.1,"a":"start"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"tx":150.2,"ty":180.5,"a":"end"}],"m":[{"n":"Lisboa","x":109.3,"y":723.3,"t":0,"i":0,"tx":145.2,"ty":704.6,"a":"start"},{"n":"Porto","x":159.8,"y":403.5,"t":0.517,"i":2,"tx":195.7,"ty":384.8,"a":"start"},{"n":"O Porriño","x":160.7,"y":271.8,"t":0.759,"i":5,"tx":196.6,"ty":253.1,"a":"start"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7,"tx":132.2,"ty":183.6,"a":"end"}],"lista":["Lisboa","Coimbra","Porto","Ponte de Lima","Tui","O Porriño","Padrón","Santiago"],"bb":[109.3,177.4,184.4,723.3]},"costa":{"d":"M159.8 403.5C157.9 399.3,150.6 383.0,148.4 378.1C146.2 373.2,147.0 378.3,146.4 374.3C145.8 370.3,145.7 360.7,144.6 353.9C143.5 347.1,140.5 340.7,139.6 333.3C138.7 325.9,139.9 314.2,139.2 309.6C138.5 305.0,136.1 309.8,135.5 305.8C134.9 301.8,135.0 290.4,135.5 285.6C136.0 280.9,135.9 281.3,138.4 277.3C140.9 273.3,146.8 265.0,150.7 261.4C154.6 257.8,159.7 257.9,161.8 255.7C163.9 253.5,164.1 251.3,163.5 248.1C162.9 244.9,159.0 242.1,158.2 236.4C157.4 230.7,158.8 220.4,158.5 213.7C158.3 207.0,155.1 202.1,156.7 196.0C158.3 189.9,166.2 180.5,168.1 177.4","g":[{"n":"Porto","x":159.8,"y":403.5,"t":0,"tx":177.7,"ty":394.1,"a":"start"},{"n":"Vila do Conde","x":148.4,"y":378.1,"t":0.067,"tx":166.3,"ty":368.7,"a":"start"},{"n":"Viana do Castelo","x":139.6,"y":333.3,"t":0.267,"tx":166.5,"ty":338,"a":"start"},{"n":"A Guarda","x":135.5,"y":305.8,"t":0.4,"tx":117.6,"ty":308.9,"a":"end"},{"n":"Vigo","x":150.7,"y":261.4,"t":0.6,"tx":168.6,"ty":264.5,"a":"start"},{"n":"Redondela","x":161.8,"y":255.7,"t":0.667,"tx":179.7,"ty":246.3,"a":"start"},{"n":"Padrón","x":156.7,"y":196,"t":0.933,"tx":174.6,"ty":199.1,"a":"start"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"tx":150.2,"ty":180.5,"a":"end"}],"m":[{"n":"Porto","x":159.8,"y":403.5,"t":0,"i":0,"tx":195.7,"ty":384.8,"a":"start"},{"n":"Viana do Castelo","x":139.6,"y":333.3,"t":0.267,"i":2,"tx":175.5,"ty":314.6,"a":"start"},{"n":"Redondela","x":161.8,"y":255.7,"t":0.667,"i":5,"tx":197.7,"ty":261.9,"a":"start"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7,"tx":132.2,"ty":183.6,"a":"end"}],"lista":["Porto","Vila do Conde","Viana do Castelo","A Guarda","Vigo","Redondela","Padrón","Santiago"],"bb":[135.5,177.4,168.1,403.5]},"norte":{"d":"M836.1 117.3C832.9 117.7,823.4 118.7,817.1 119.9C810.8 121.1,804.4 123.9,798.3 124.4C792.2 124.9,785.7 122.4,780.4 122.7C775.1 123.0,771.8 126.8,766.4 126.4C761.0 126.0,755.4 120.0,748.1 120.1C740.8 120.2,728.4 127.3,722.8 127.2C717.2 127.1,719.0 122.2,714.4 119.6C709.8 117.0,701.3 113.4,694.9 111.4C688.5 109.4,679.7 108.8,675.7 107.5C671.7 106.2,675.2 104.8,671.0 103.6C666.8 102.4,656.2 100.8,650.4 100.4C644.6 100.0,643.6 99.4,636.3 101.0C629.0 102.6,614.7 108.5,606.8 110.2C598.9 111.9,593.6 110.8,588.8 110.9C584.0 111.0,585.8 111.3,578.1 110.6C570.4 109.8,553.7 108.0,542.8 106.4C531.9 104.8,524.1 102.4,512.9 101.0C501.7 99.6,485.3 99.7,475.4 98.2C465.4 96.7,461.3 93.4,453.2 91.8C445.1 90.2,436.5 89.2,427.1 88.7C417.7 88.2,404.4 88.8,396.7 88.9C389.0 89.0,386.1 89.0,381.1 89.3C376.1 89.6,372.1 90.5,366.7 90.7C361.3 90.9,356.7 90.6,348.4 90.7C340.1 90.8,326.3 89.8,316.9 91.3C307.5 92.8,297.2 97.5,291.9 99.9C286.6 102.3,288.1 103.3,285.0 105.5C281.9 107.8,278.3 110.5,273.0 113.4C267.8 116.3,257.8 119.1,253.5 122.7C249.2 126.3,253.1 129.7,247.4 135.2C241.7 140.7,226.4 149.7,219.5 155.7C212.6 161.7,211.6 168.0,206.0 171.0C200.4 174.0,192.2 172.7,185.9 173.8C179.6 174.9,171.1 176.8,168.1 177.4","g":[{"n":"Irún","x":836.1,"y":117.3,"t":0,"tx":836.1,"ty":101.7,"a":"middle"},{"n":"Bilbao","x":722.8,"y":127.2,"t":0.176,"tx":722.8,"ty":142.8,"a":"middle"},{"n":"Santander","x":636.3,"y":101,"t":0.353,"tx":636.3,"ty":85.4,"a":"middle"},{"n":"Gijón","x":453.2,"y":91.8,"t":0.559,"tx":453.2,"ty":76.2,"a":"middle"},{"n":"Ribadeo","x":316.9,"y":91.3,"t":0.735,"tx":316.9,"ty":75.7,"a":"middle"},{"n":"Mondoñedo","x":285,"y":105.5,"t":0.794,"tx":302.9,"ty":108.6,"a":"start"},{"n":"Arzúa","x":206,"y":171,"t":0.941,"tx":232.9,"ty":157,"a":"start"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"tx":150.2,"ty":180.5,"a":"end"}],"m":[{"n":"Irún","x":836.1,"y":117.3,"t":0,"i":0,"tx":836.1,"ty":86.1,"a":"middle"},{"n":"Santander","x":636.3,"y":101,"t":0.353,"i":2,"tx":636.3,"ty":69.8,"a":"middle"},{"n":"Mondoñedo","x":285,"y":105.5,"t":0.794,"i":5,"tx":285,"ty":74.3,"a":"middle"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7,"tx":132.2,"ty":183.6,"a":"end"}],"lista":["Irún","Bilbao","Santander","Gijón","Ribadeo","Mondoñedo","Arzúa","Santiago"],"bb":[168.1,88.7,836.1,177.4]},"ingles":{"d":"M198.5 98.3C199.9 98.0,205.7 94.8,206.9 96.6C208.1 98.4,206.5 104.2,205.5 108.9C204.5 113.6,203.5 119.9,200.8 124.9C198.1 129.9,193.6 132.9,189.3 139.1C185.0 145.3,178.6 155.4,175.1 161.8C171.6 168.2,169.3 174.8,168.1 177.4","g":[{"n":"Ferrol","x":198.5,"y":98.3,"t":0,"tx":198.5,"ty":82.7,"a":"middle"},{"n":"Pontedeume","x":205.5,"y":108.9,"t":0.333,"tx":187.6,"ty":112,"a":"end"},{"n":"Betanzos","x":200.8,"y":124.9,"t":0.5,"tx":173.9,"ty":129.6,"a":"end"},{"n":"Bruma","x":189.3,"y":139.1,"t":0.667,"tx":216.2,"ty":115.7,"a":"start"},{"n":"Sigüeiro","x":175.1,"y":161.8,"t":0.833,"tx":157.2,"ty":164.9,"a":"end"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"tx":141.2,"ty":182.1,"a":"end"}],"m":[{"n":"Ferrol","x":198.5,"y":98.3,"t":0,"i":0,"tx":198.5,"ty":67.1,"a":"middle"},{"n":"Betanzos","x":200.8,"y":124.9,"t":0.5,"i":2,"tx":233.7,"ty":117.4,"a":"start"},{"n":"Bruma","x":189.3,"y":139.1,"t":0.667,"i":3,"tx":149.6,"ty":167.9,"a":"end"},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":5,"tx":132.2,"ty":183.6,"a":"end"}],"lista":["Ferrol","Pontedeume","Betanzos","Bruma","Sigüeiro","Santiago"],"bb":[168.1,96.6,206.9,177.4]}}};
  var chips = $('#chips'), rt = $('#rt'), rtBg = $('#rtBg'), nodes = $('#rNodes');
  var otras = $('#mOtras'), lista = $('#rLista'), ultima = null;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var mapa = $('#rMap'), ASP = GEO.meta.W / GEO.meta.H;
  var esc = $('.mesc'), bru = $('.mbru'), escLinea = esc.querySelector('path'), escTxt = esc.querySelector('text');
  var sant = $('.msant'), tramaP = $('#mDots'), tramaC = tramaP.querySelector('circle');
  var vbActual = [0,0,GEO.meta.W,GEO.meta.H], vbAnim = null, uPx = 1;

  /* El encuadre se acerca a la ruta elegida. A la misma escala para todas, el
     Camino Inglés (122 km) quedaba en cuatro píxeles con los nombres pisados.
     La barra de escala se recalcula, así que sigue siendo honesto. */
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden && destinoVb) verVb(destinoVb);
  });
  function encuadre(bb){
    var cx = (bb[0]+bb[2])/2, cy = (bb[1]+bb[3])/2;
    var w = Math.max(bb[2]-bb[0], 150) * 1.55, h = Math.max(bb[3]-bb[1], 120) * 1.35;
    /* La forma de la tarjeta se adapta a la ruta, entre estos dos límites. Con
       una proporción fija, el Norte (668 x 89) dejaba media tarjeta vacía y el
       Portugués salía como una tira. La altura se mueve sola al cambiar. */
    var a = w/h;
    if(a > 2.2) h = w/2.2; else if(a < 0.85) w = h*0.85;
    return [cx-w/2, cy-h/2, w, h];
  }
  function verVb(vb){
    mapa.setAttribute('viewBox', vb.map(function(n){ return n.toFixed(1); }).join(' '));
    var k = vb[2]/GEO.meta.W;
    mapa.style.setProperty('--k', k);
    // barra de escala: se elige una distancia redonda que ocupe ~un cuarto del ancho
    var kmVisibles = vb[2]*GEO.meta.kmU, elegido = 500;
    [500,200,100,50,20,10,5].forEach(function(v){ if(v <= kmVisibles*0.34) { elegido = Math.min(elegido, v); } });
    [5,10,20,50,100,200,500].forEach(function(v){ if(v <= kmVisibles*0.34) elegido = v; });
    var largo = elegido/GEO.meta.kmU;
    var u = uPx, t7 = 6*u, t14 = 12*u;
    escLinea.setAttribute('d','M0 0h'+largo.toFixed(1)+'M0 -'+t7.toFixed(1)+'v'+t14.toFixed(1)+'M'+largo.toFixed(1)+' -'+t7.toFixed(1)+'v'+t14.toFixed(1));
    escTxt.setAttribute('x',(largo/2).toFixed(1)); escTxt.setAttribute('y',(-9*u).toFixed(1));
    escTxt.textContent = elegido+' km';
    esc.setAttribute('transform','translate('+(vb[0]+vb[2]*0.05).toFixed(1)+','+(vb[1]+vb[3]*0.93).toFixed(1)+')');
    bru.setAttribute('transform','translate('+(vb[0]+vb[2]*0.94).toFixed(1)+','+(vb[1]+vb[3]*0.84).toFixed(1)+') scale('+u.toFixed(4)+')');
    /* El halo de Santiago y la retícula se mantienen del mismo tamaño en
       pantalla: si no, al acercarse al Inglés el halo era una mancha enorme y
       los puntos de la retícula quedaban a 80 px unos de otros. */
    sant.setAttribute('r', (34*uPx).toFixed(1));
    tramaP.setAttribute('width', (26*uPx).toFixed(2));
    tramaP.setAttribute('height', (26*uPx).toFixed(2));
    tramaC.setAttribute('cx', (1.4*uPx).toFixed(2));
    tramaC.setAttribute('cy', (1.4*uPx).toFixed(2));
    tramaC.setAttribute('r', (1.4*uPx).toFixed(2));
    vbActual = vb;
  }
  var destinoVb = null;
  function irA(vb){
    destinoVb = vb;
    /* En una pestaña de fondo requestAnimationFrame no corre: la animación se
       quedaba en el primer fotograma y el mapa aparecía sin acercar, con los
       nombres calculados para el encuadre de destino. Si no se ve, se salta. */
    if(REDUCE || document.hidden){ verVb(vb); return; }
    var de = vbActual.slice(), t0 = performance.now(), dur = 780;
    if(vbAnim) cancelAnimationFrame(vbAnim);
    (function paso(now){
      var q = Math.min(1,(now-t0)/dur), e = q<.5 ? 4*q*q*q : 1-Math.pow(-2*q+2,3)/2;
      verVb([0,1,2,3].map(function(i){ return de[i] + (vb[i]-de[i])*e; }));
      if(q<1) vbAnim = requestAnimationFrame(paso);
    })(t0);
  }
  var nName = $('#rName'), nFrom = $('#rFrom'), nWhen = $('#rWhen');
  if(!chips) return;

  function contar(el, fin){
    var ini = parseInt(el.textContent.replace(/\D/g,''),10) || 0;
    if(REDUCE){ el.textContent = fin.toLocaleString('es-ES'); return; }
    var t0 = performance.now(), dur = 900;
    (function paso(now){
      var k = Math.min(1,(now-t0)/dur), e = 1 - Math.pow(1-k,3);
      el.textContent = Math.round(ini + (fin-ini)*e).toLocaleString('es-ES');
      if(k<1) requestAnimationFrame(paso);
    })(t0);
  }
  function pintar(r){
    nName.textContent = r.nombre; nFrom.textContent = r.desde; nWhen.textContent = r.cuando;
    var g = GEO.rutas[r.id];
    if(!g) return;                                  // ruta sin geometría: no rompe nada

    // los otros cuatro Caminos, de fondo
    otras.textContent = '';
    Object.keys(GEO.rutas).forEach(function(k){
      if(k === r.id) return;
      var pth = document.createElementNS(SVGNS,'path');
      pth.setAttribute('class','mghost'); pth.setAttribute('d', GEO.rutas[k].d);
      otras.appendChild(pth);
    });

    /* Si la línea todavía está a medio dibujar (la animación de la primera
       vez que entra en pantalla dura casi un segundo, y el editor de temas
       de Shopify la puede interrumpir otra vez al cambiar a vista móvil),
       un cambio de ruta en ese momento dejaba el trazo a medias. No basta
       con poner la transición a 0s y "añadir" la clase: si la clase ya
       estaba puesta (la línea a medio animar hacia el final), añadirla de
       nuevo no hace nada y la animación a medias se queda congelada ahí.
       Por eso se QUITA y se vuelve a PONER siempre, cada vez forzando un
       salto instantáneo (a "sin dibujar" y luego a "dibujada del todo"),
       así no importa en qué punto de cualquier animación estuviera antes. */
    rt.style.transitionDuration = '0s';
    rt.classList.remove('on');
    void rt.getBoundingClientRect();
    rtBg.setAttribute('d', g.d); rt.setAttribute('d', g.d);
    rt.classList.add('on');
    void rt.getBoundingClientRect();
    rt.style.transitionDuration = '';
    var vb = encuadre(g.bb);
    /* Los nombres y los puntos se calculan para verse SIEMPRE del mismo tamaño
       en pantalla (13 px), sea el mapa grande o pequeño y esté cerca o lejos.
       Antes se escalaban con el zoom y en el móvil salían de 4 px. */
    var anchoReal = mapa.getBoundingClientRect().width || 620;
    /* La altura se calcula aquí y se fija en el elemento. Leerla del CSS con
       getComputedStyle no vale: con max-height:min(58vh,520px) el navegador
       devuelve la fórmula sin resolver y los nombres salían gigantes. */
    var tope = Math.min(innerHeight * (anchoReal < 470 ? 0.64 : 0.58), anchoReal < 470 ? 460 : 520);
    var altoReal = Math.min(tope, anchoReal * vb[3] / vb[2]);
    mapa.style.height = Math.round(altoReal) + 'px';
    var ratio = Math.min(anchoReal / vb[2], altoReal / vb[3]);
    var kTxt = 13 / ratio, kPto = 6 / ratio;
    uPx = 1 / ratio;                 // unidades del dibujo por píxel de pantalla
    mapa.style.setProperty('--u', uPx.toFixed(4));
    irA(vb);
    var movil = anchoReal < 470;   // no cabe todo: cuatro nombres en vez de ocho
    var conNombre = {};
    (movil ? g.m : g.g).forEach(function(h){ conNombre[h.n] = h; });
    /* La lista de abajo son los pueblos DE VERDAD (el final de cada etapa,
       segun Gronze), no los puntos que caben en el mapa. Gustavo, 16/08:
       «si no sabes cuantos pueblos son, no pongas un numero exacto, porque
       al final estas confirmando; y si sabes, enumeralos». El mapa sigue
       con sus seis u ocho nombres, que es lo que cabe sin volverse una
       mancha; la respuesta completa vive aqui, en texto. */
    lista.textContent = (r.pueblos || g.lista).join(' · ');

    // En un móvil no caben ocho nombres legibles: se enseñan cuatro con la letra
    // grande y la lista completa va debajo en texto.

    nodes.textContent = '';
    g.g.forEach(function(h,i){
      var fin = i === g.g.length - 1;
      var nodo = document.createElementNS(SVGNS,'g');
      nodo.setAttribute('class','nd' + (fin ? ' nd--end' : ''));
      var c = document.createElementNS(SVGNS,'circle');
      c.setAttribute('cx',h.x); c.setAttribute('cy',h.y); c.setAttribute('r', (kPto*(fin?1.25:1)).toFixed(2));
      nodo.appendChild(c);
      var e = conNombre[h.n];
      if(e){
        // el texto y su separación se multiplican por el zoom: así se ve
        // siempre del mismo tamaño en pantalla, esté cerca o lejos
        var kSep = kTxt / (movil ? 26 : 13);
        var tx = document.createElementNS(SVGNS,'text');
        tx.setAttribute('x', (h.x + (e.tx-h.x)*kSep).toFixed(1));
        tx.setAttribute('y', (h.y + (e.ty-h.y)*kSep).toFixed(1));
        tx.setAttribute('text-anchor', e.a);
        /* En estilo, no en atributo: la hoja de estilos (.nd text{font:600 13px})
           gana a los atributos de presentación del SVG y los nombres salían a
           13 unidades del dibujo, o sea 40 px en pantalla. */
        tx.style.fontSize = kTxt.toFixed(2) + 'px';
        tx.style.strokeWidth = (kTxt*0.27).toFixed(2) + 'px';
        tx.textContent = h.n;
        nodo.appendChild(tx);
      }
      nodes.appendChild(nodo);
      nodo.classList.add('on');
    });

    contar($('[data-num=km]'), r.km);
    contar($('[data-num=dias]'), r.dias);
    /* Antes: r.hitos.length, o sea el numero de PUNTOS DEL MAPA. Salia
       "8 pueblos" en el Frances, en el Portugues, en el Norte y en la
       Costa, porque los cuatro tienen ocho puntos. Nadie hace el Frances
       pasando por ocho pueblos. Ahora es el numero de etapas publicado. */
    contar($('[data-num=etapas]'), r.etapas);
    ultima = r;
  }
  // Al girar el móvil o cambiar de tamaño cambia el juego de etiquetas.
  var tRedibuja = null;
  addEventListener('resize', function(){
    clearTimeout(tRedibuja);
    tRedibuja = setTimeout(function(){ if(ultima) pintar(ultima); }, 220);
  });
  var interactuado = false;
  RUTAS.forEach(function(r,i){
    var b = document.createElement('button');
    b.type='button'; b.className='chip'; b.textContent=r.corto; b.setAttribute('aria-pressed', String(i===0));
    b.addEventListener('click', function(){
      interactuado = true;
      $$('.chip',chips).forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true'); pintar(r);
    });
    chips.appendChild(b);
  });
  // Se pinta ya, sin esperar a nada. Antes esperaba a que la sección entrase en
  // pantalla y, si el observador no disparaba (pestaña en segundo plano), el
  // mapa se quedaba vacío. El dibujo de la línea sí se reanima al entrar.
  pintar(RUTAS[0]);
  var visto = false;
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting && !visto){
        visto = true;
        // Si el usuario ya tocó un chip antes de que esto se dispare (el observador
        // es async y puede llegar tarde respecto a un toque casi simultáneo), no se
        // toca nada: pintar() ya dejó la línea actual bien dibujada y reiniciar aquí
        // la animación de entrada la dejaría a medias otra vez.
        if(interactuado) return;
        rt.classList.remove('on');
        requestAnimationFrame(function(){ rt.classList.add('on'); });
      }
    });
  }, {threshold:.25}).observe($('#tu-camino'));
})();

/* ---------- EL VÍDEO-RECUERDO QUE SE MONTA ---------- */
(function(){
  var box = $('#player'); if(!box) return;
  var drawn = $('#fDrawn'), dot = $('#fDot'), bar = $('#fBar'), end = $('#fEnd'), btn = $('#fPlay');
  var piezas = $$('.fph,.fnote,.flbl', box);
  var largo = drawn.getTotalLength();
  var t0 = null, jugando = false, dur = 7200, p = 0, hecho = false;

  function pintar(q){
    p = q;
    drawn.style.strokeDashoffset = String(1 - q);
    var pt = drawn.getPointAtLength(largo * q);
    dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
    bar.style.width = (q*100) + '%';
    piezas.forEach(function(el){ el.classList.toggle('on', q >= parseFloat(el.dataset.at)); });
    var fin = q > .93;
    end.classList.toggle('on', fin);
    if(fin && !hecho){ hecho = true; numeros(); }
    if(!fin) hecho = false;
  }
  function numeros(){
    $$('[data-fnum]', end).forEach(function(el){
      var f = +el.dataset.fnum;
      if(REDUCE){ el.textContent = f; return; }
      var s = performance.now();
      (function paso(now){
        var k = Math.min(1,(now-s)/1100), e = 1 - Math.pow(1-k,3);
        el.textContent = Math.round(f*e);
        if(k<1) requestAnimationFrame(paso);
      })(s);
    });
  }
  function tic(now){
    if(!jugando) return;
    if(t0 === null) t0 = now - p*dur;
    var q = Math.min(1, (now - t0)/dur);
    pintar(q);
    if(q < 1) requestAnimationFrame(tic);
    else { jugando = false; t0 = null; etiqueta(false); }
  }
  function etiqueta(activo){
    btn.querySelector('span').textContent = activo ? 'Pausa' : (p >= 1 ? 'Verlo otra vez' : 'Ver cómo se monta');
    btn.querySelector('path').setAttribute('d', activo ? 'M7 5h4v14H7zM13 5h4v14h-4z' : 'M8 5v14l11-7z');
  }
  function play(){
    if(p >= 1){ p = 0; pintar(0); }
    jugando = true; t0 = null; etiqueta(true); requestAnimationFrame(tic);
  }
  function pausa(){ jugando = false; t0 = null; etiqueta(false); }
  btn.addEventListener('click', function(){ jugando ? pausa() : play(); });

  if(REDUCE){ pintar(1); etiqueta(false); }
  else {
    pintar(0);
    var arrancado = false;
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !arrancado){ arrancado = true; setTimeout(play, 400); }
        else if(!e.isIntersecting && jugando){ pausa(); }
      });
    }, {threshold:.45}).observe(box);
  }
})();

/* ---------- demo del móvil ---------- */
(function(){
  var demo = $('[data-demo]'); if(!demo) return;
  var scrs = $$('[data-scr]', demo), pasos = $$('[data-steps] li', demo);
  var dots = $('[data-dots]', demo), replay = $('[data-replay]', demo), typed = $('[data-typed]', demo);
  var NOTA = 'Los últimos 100 km. Hoy caminé con Anke, de Bremen. Nos perdimos dos veces y nos reímos las dos.';
  var aPaso = [0,0,1,1,2], ESPERA = [1900,3000,2600,3800,3400];
  var etiquetas = ['En reposo','Tu diario','Hacer la foto','Escribir la nota','Guardado'];
  var cur = 0, auto = !REDUCE, timer = null, typeT = null, dentro = false;
  var botones = etiquetas.map(function(txt,i){
    var b = document.createElement('button');
    b.type='button'; b.setAttribute('role','tab'); b.setAttribute('aria-label',txt);
    b.addEventListener('click', function(){ auto=false; ir(i); });
    dots.appendChild(b); return b;
  });
  function limpiar(){ clearTimeout(timer); clearInterval(typeT); timer=typeT=null; }
  function escribir(){ var i=0; typed.textContent=''; typeT=setInterval(function(){ typed.textContent=NOTA.slice(0,++i); if(i>=NOTA.length) clearInterval(typeT); },26); }
  function ir(i){
    limpiar();
    cur = (i + scrs.length) % scrs.length;
    scrs.forEach(function(s,k){ s.classList.toggle('on', k===cur); });
    botones.forEach(function(b,k){ b.setAttribute('aria-current', String(k===cur)); });
    pasos.forEach(function(el,k){ el.classList.toggle('on', k===aPaso[cur]); });
    if(cur===3){ REDUCE ? typed.textContent=NOTA : escribir(); }
    if(auto && dentro) timer = setTimeout(function(){ ir(cur+1); }, ESPERA[cur]);
  }
  replay.addEventListener('click', function(){ auto=true; ir(0); });
  new IntersectionObserver(function(es){
    es.forEach(function(e){ dentro = e.isIntersecting; if(dentro && auto) ir(cur); else limpiar(); });
  }, {threshold:.3}).observe(demo);
  REDUCE ? (auto=false, ir(1)) : ir(0);
})();

/* ---------- perfil de emergencia ---------- */
(function(){
  var wrap = $('[data-switches]'); if(!wrap) return;
  var filas = $$('.idrow'), vacio = $('[data-empty]');
  var inputs = $$('input[type=checkbox]', wrap);
  function sync(){
    var v = 0;
    inputs.forEach(function(inp){
      var f = filas.filter(function(x){ return x.dataset.row === inp.dataset.field; })[0];
      if(!f) return;
      f.hidden = !inp.checked;
      if(inp.checked) v++;
    });
    vacio.hidden = v > 0;
  }
  inputs.forEach(function(i){ i.addEventListener('change', sync); });
  sync();
})();

/* ---------- galería ---------- */
(function(){
  var main = $('#galMain'), wrap = $('[data-thumbs]');
  if(!main || !wrap) return;
  var bs = $$('button', wrap);
  bs.forEach(function(b){
    b.addEventListener('click', function(){
      bs.forEach(function(t){
        var on = t === b;
        t.setAttribute('aria-current', String(on));
        t.style.borderColor = on ? 'var(--gold)' : 'var(--line)';
        t.style.boxShadow = on ? '0 0 0 1px var(--gold)' : 'none';
      });
      main.style.opacity = '0';
      setTimeout(function(){
        main.src = b.dataset.src;
        var im = b.querySelector('img'); if(im) main.alt = im.alt;
        main.style.opacity = '1';
      }, 170);
    });
  });
  main.style.transition = 'opacity .35s var(--ease)';
})();

/* ---------- barra de compra en móvil ---------- */
(function(){
  var b = $('#buybar'), hero = $('.hero'), f = $('#fundadores');
  if(!b || !hero) return;
  function chk(){
    var pasado = hero.getBoundingClientRect().bottom < 0;
    var enFund = f && f.getBoundingClientRect().top < innerHeight*.8 && f.getBoundingClientRect().bottom > innerHeight*.2;
    b.classList.toggle('on', pasado && !enFund);
  }
  addEventListener('scroll', chk, {passive:true}); chk();
})();

/* ---------- alta en la lista (demostración local) ---------- */
(function(){
  var f = $('#subForm'); if(!f) return;
  var i = $('#subEmail'), n = $('#subNote');
  f.addEventListener('submit', function(e){
    e.preventDefault();
    var ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(i.value.trim());
    n.style.color = ok ? 'var(--gold-b)' : '#E8A0A0';
    n.textContent = ok ? '¡Hecho! Te acabamos de mandar un correo de bienvenida. Revisa también spam.'
                       : 'Revisa el correo: parece que falta algo.';
    if(ok) f.reset();
  });
})();
})();
